module.exports = __webpack_public_path__ + "static/tile_boys-dc65dea27bfafb99e38e9ee8591670f9.jpg";